export default __webpack_public_path__ + "static/media/coliberty-dashboard-icon.20163f9d.png";